<template>
  <section>
    <section class="full-screen-autoheight">
      <swiper id="swiper" class="full-content" :options="swiperOption">
        <swiper-slide>
          <div class="full-content bg-just" :style="{ backgroundImage: 'url(/static/img/banner.jpg)' }"></div>
        </swiper-slide>
        <swiper-slide>
          <div class="full-content bg-just" :style="{backgroundImage: 'url(/static/img/unmannedstore/1bg.jpg)'}"></div>
        </swiper-slide>
        <swiper-slide>
          <div class="full-content bg-just" :style="{backgroundImage: 'url(/static/img/unmannedstore/2bg.jpg)'}"></div>
        </swiper-slide>
        <div class="swiper-pagination"  slot="pagination"></div>
        <div class="swiper-btn-prev" slot="button-prev" style="opacity:.2;position: absolute;left: 130px;top:0;bottom:0;margin:auto;width: 64px;height: 115px;z-index: 1;">
          <img src="/static/img/intelmarket/left_arrow.svg" />
        </div>
        <div class="swiper-btn-next" slot="button-next" style="opacity:.2;position: absolute;right: 130px;top:0;bottom:0;margin:auto;width: 64px;height: 115px;z-index: 1;">
          <img src="/static/img/intelmarket/right_arrow.svg" />
        </div>
      </swiper>
    </section>
    <section id="b" class="full-screen bg-grey anchor">
      <div class="m-w full-content">
        <div class="bg-just scroll-animate" data-animate-class="fade-in-up-1s" :style="{backgroundImage: 'url(/static/img/ucs.png)', width: '1441px', height: '825px',left: '45px',top: '196px',position:'relative' }"></div>
        <div class="m-w bias-bottom scroll-animate" data-animate-delay="100" data-animate-class="fade-in-up-1s">
          <div class="intro font24">
            <div class="flex-around w100">
              <svg width="100" height="100" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 99.076 57.795">
                <g id="eye" transform="translate(0 0)">
                  <path id="eye_1" data-name="eye_1" class="cls-1" d="M226.844,316.949C215.156,303.481,199,288,177.538,288c-8.669,0-16.616,2.451-25,7.689-7.07,4.438-14.32,10.682-24.279,20.951L128,316.9l1.729,1.78c14.216,14.552,26.5,27.117,47.809,27.117,9.417,0,18.551-3.07,27.917-9.392,7.973-5.392,14.758-12.23,20.2-17.751l1.419-1.419-.232-.284Zm-49.306-24.821c8.54,0,16.745,2.451,25.079,7.9,6.166,4.025,12.23,9.469,19.015,17.055-9.882,9.985-24.717,24.588-44.094,24.588a42.192,42.192,0,0,1-24.3-7.276c-7.1-4.67-13.494-11.172-19.66-17.493C148.822,301.494,161.541,292.128,177.538,292.128Z" transform="translate(-128 -288)"/>
                  <path id="eye_2" data-name="eye_2" class="cls-1" d="M372.641,393.282A20.641,20.641,0,1,0,352,372.641,20.668,20.668,0,0,0,372.641,393.282Zm0-37.076a16.435,16.435,0,1,1-16.487,16.435A16.512,16.512,0,0,1,372.641,356.206Z" transform="translate(-323.103 -343.744)"/>
                  <g id="eye_3_move" class="hover-rotate" transform="translate(0,0)">
                    <path id="eye_3" data-name="eye_3" class="cls-1" d="M436.815,428.385a8.287,8.287,0,0,1-8.2,8.256A8.534,8.534,0,0,1,420.3,428.2a8.382,8.382,0,0,1,8.256-8.076V416a12.423,12.423,0,1,0,12.385,12.436v-.052Z" transform="translate(-379.021 -399.487)" />
                  </g>
                </g>
              </svg>
              <div class="flex-col-around text-right font18">
                <span class="red font26 lighter">+</span>
                <span class="c6">智能识别</span>
              </div>
            </div>
            <div class="c9 font18">Intelligent recognition</div>
          </div>
          <div class="intro font24">
            <div class="flex-around w100">
              <svg width="70" height="70" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 69.353 69.354">
                <g id="pay" transform="translate(0 0)">
                  <path id="pay_1" data-name="pay_1" class="cls-1" d="M365.92,331.891a1.549,1.549,0,1,0,0,3.1h8.349v10.978a1.549,1.549,0,1,0,3.1,0V334.987h8.315a1.549,1.549,0,1,0,0-3.1h-8.315v-6.659a1.55,1.55,0,0,0,.481-.076h7.85a1.549,1.549,0,1,0,0-3.1h-7.581l8.655-8.655a1.549,1.549,0,1,0-2.189-2.189l-8.755,8.755-8.759-8.76a1.549,1.549,0,1,0-2.189,2.189l8.66,8.66H365.92a1.549,1.549,0,1,0,0,3.1h7.886a1.553,1.553,0,0,0,.463.075v6.659Z" transform="translate(-341.03 -291.585)"/>
                  <g id="pay_2_move" class="hover-rotate" transform="translate(0 0)">
                    <path id="pay_2" data-name="pay_2" class="cls-1" d="M97.956,63.279A34.684,34.684,0,0,0,67.78,115.05a1.584,1.584,0,0,0,.346.6l.054.093.018-.018a1.585,1.585,0,0,0,2.242-2.242l0,0a31.583,31.583,0,1,1,10.02,10.779l-.014.014a1.586,1.586,0,1,0-1.476,2.711,34.678,34.678,0,1,0,18.981-63.7Z" transform="translate(-63.279 -63.279)"/>
                  </g>
                </g>
              </svg>
              <div class="flex-col-between text-right font18">
                <span class="red font26 lighter">+</span>
                <span class="c6">智能结算</span>
              </div>
            </div>
            <div class="c9 font18">Intelligent settlement</div>
          </div>
          <div class="intro font24">
            <div class="flex-around w100">
              <svg width="60" height="70" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 55.9 69.4">
                <path id="secure_1" class="st0" d="M27.9,69.4L12.7,61l-0.1,0C4.8,55.8,0,47,0,37.5V5.6L28,0l28,5.6v31.9
                                    c0,9.4-4.8,18.3-12.7,23.4l-0.1,0l-0.1,0L27.9,69.4z M14.9,57.4l13,7.2L41,57.4c6.7-4.4,10.7-11.9,10.7-19.9V9L28,4.2L4.1,9v28.5
                                    C4.1,45.5,8.2,53,14.9,57.4L14.9,57.4z"/>
                <polyline id="secure_2" class="st1 secure_storke" points="19.4,31.6 27.4,39.5 40.1,26.8 "/>
              </svg>
              <div class="flex-col-between text-right font18">
                <span class="red font26 lighter">+</span>
                <span class="c6">智能防盗</span>
              </div>
            </div>
            <div class="c9 font18">F-Secure Mobile Security</div>
          </div>
        </div>
      </div>
    </section>
    <section id="c" class="full-screen anchor">
      <div class="m-w full-content text-center">
        <h3 class="m0 font60 scroll-animate" data-animate-class="fade-in-up-1s" style="padding-top: 210px;margin-bottom: 30px;">
          <span>城市</span><!--
                    --><span style="color: #FF2A00;">,</span><!--
                    --><span>供应网络</span>
        </h3>
        <div class="n-mb5 font20 normal-lineheight scroll-animate" data-animate-delay="1000" data-animate-class="fade-in-up-1s">
          <p class="m0">完善的供应链体系，支撑全国城市快速拓展。</p>
          <p class="m0">支持合作伙伴自营产品售卖，全国SKU超过30万种，全国供应链公司合作加盟</p>
          <p class="m0">专业的无人零售配送团队。支持个性定制的仓储加工中心，软件管理系统，帮助供应链体系高效运行。</p>
        </div>
        <div class="flex-center scroll-animate" data-animate-delay="1000" data-animate-class="fade-in-up-1s" style="margin-top: 60px;">
          <div class="chain">
            <img src="/static/img/supply_chain.jpg" />
            <div class="chain-text">
              <span class="font50">智能配货</span>
              <span class="font24 lighter">Intelligent distribution</span>
            </div>
          </div>
          <div class="chain" style="margin-left: 30px;">
            <img src="/static/img/intel_deliver.jpg" />
            <div class="chain-text">
              <span class="font50">供应链</span>
              <span class="font24 lighter">Supply chain</span>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section id="animate" data-motion="true" class="full-screen bg-grey anchor">
      <div class="m-w text-center" style="padding-top: 193px;">
        <h5 class="font70 red m0 scroll-animate" data-animate-class="fade-in-up-1s" style="margin-bottom:70px;">智慧无人超市</h5>
        <div class="n-mb5 font20 c6 normal-lineheight scroll-animate" data-animate-delay="600" data-animate-class="fade-in-up-1s" style="margin-bottom: 80px;">
          <p class="m0">一家24小时经营，年销售额30万左右的传统便利店，投建成本在30万元以上。</p>
          <p class="m0">而智慧无人超市的建设成本不到10万元。由于无人值守，智慧超市的毛利率高达30%。</p>
        </div>
        <div class="motion-text font240 c3 scroll-animate" data-animate-method="animateNum" style="font-size:300px;position:absolute;;left:0;right:0;margin:auto;">
          <span>{{cost}}</span><!--
                    --><span>W</span><!--
                    --><span>/</span><!--
                    --><span>{{profit}}</span><!--
                    --><span>%</span>
        </div>
      </div>
      <Footer :absolute=true />
    </section>
  </section>
</template>

<script>
  import justHeight from '@/api/justHeight'
  import VueScroll from '@/api/animateDom'
  import { ScrollToTop } from '@/api/scroll'
  import Footer from '@/components/Footer'

  export default {
    components: { Footer },
    data() {
      var self = this;

      return {
        eyeHover: false,
        profit: 0,
        cost: 0,
        swiperOption:{
          pagination: {
            el: '.swiper-pagination',
            dynamicBullets: true
          },
          loop: true,
          speed: 1000,
          autoplayDisableOnInteraction:false,
          resistanceRatio: 0,
          slidesPerView: 1,
          spaceBetween: 30,
          navigation: {
            nextEl: '.swiper-btn-next',
            prevEl: '.swiper-btn-prev'
          },
          on:{
            init(){
              //2s后自���滑动
              this.timeout = setTimeout(()=>{
                this.slideNext();
              }, 2000);
            },
            //执行完动画后再次设置2s滑动
            //防止点击按钮导致页面停留时间不是预期的时间
            transitionEnd() {
              if(this.timeout)
                clearTimeout(this.timeout)
              this.timeout = setTimeout(()=>{
                this.slideNext();
              }, 2000);
            }
          }
        }
      }
    },
    mounted() {
      justHeight.justAll();

      this.vueScroll = new VueScroll(this, {
        withScroll: true,
        delay: 800
      });
      this.vueScroll.run();
    },
    destroyed(){
      this.vueScroll.stop();
      ScrollToTop();
    },
    methods:{
      animateNum(){
        animateNumber(0, 10, 1000, (num)=>{ this.cost = num; });
        animateNumber(0, 30, 3000, (num)=>{ this.profit = num; });
      }
    }
  }
  import BezierCurve from '@/api/bezier'

  function animateNumber(from, to, duration, outFn) {
    var bezierFn = new BezierCurve({
      time: duration,
      to,
      from,
      outFn
    })

    bezierFn.runWithCalc();
  }
</script>

<style>

  .intro:hover .hover-rotate path {
    fill: #FF2A00;
  }

  .intro:hover #eye_3_move {
    transform-origin: 49.538px 28.8975px;
  }

  .intro:hover #pay_2_move{
    transform-origin: 34.6765px 34.677px;
  }

  .intro:hover .hover-rotate{
    animation: rotate 1s linear infinite;
  }

  .intro:hover .secure_storke{
    stroke: #FF2A00;
    animation: hook_show .5s linear;
  }

  .secure_storke {
    stroke-dasharray: 30;
    stroke-dashoffset: 0;
  }

  @keyframes hook_show {
    from{
      stroke-dashoffset: 30;
    }
    to{
      stroke-dashoffset: 0;
    }
  }

  @keyframes rotate {
    from {
      transform: rotate(0);
    }
    to {
      transform: rotate(360deg);
    }
  }

  /*------ svg ------*/

  .intro {
    width: 255px;
    height: 175px;
    border-radius: 20px;
    border: 1px solid #333333;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    align-items: center;
  }

  .motion-text {
    font-weight: bold;
  }

  .chain {
    width: 508px;
    position: relative;
  }

  .chain-text {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #ffffff;
    flex-direction: column;
  }

  .chain img {
    width: 100%;
    height: 100%;
  }

</style>



// WEBPACK FOOTER //
// src/pages/Main/index.vue